import React, { Component } from "react";
import { Provider } from "./createContext";

export class ContextProvider extends Component {
  state = {
    selectedLanguage: "en",
  };

  saveSelectedLanguage = (option) => {
    //changes languages accordingly and set LanguageCode
    let languageCode = "en";
    if (option === "Spanish") languageCode = "es";
    else if (option === "Arabic") languageCode = "ar";
    else if (option === "Hindi") languageCode = "hi";
    else if (option === "Dutch") languageCode = "nl";
    else if (option === "French") languageCode = "fr";

    console.log({ languageCode });

    this.setState({ selectedLanguage: languageCode });
  };

  handleColorChange = (color) => {
    localStorage.setItem("themeColor", color);
  };

  render() {
    const { selectedLanguage } = this.state;
    const { saveSelectedLanguage, handleColorChange } = this;
    const contextObj = {
      selectedLanguage,
      saveSelectedLanguage,
      handleColorChange,
    };
    return <Provider value={contextObj}>{this.props.children}</Provider>;
  }
}

export default ContextProvider;
